/* eslint-disable max-len */
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {
  getFormularioPoliticaMunicipalAgriculturaFamiliarByUUID
} from 'api/forms/pacote_formularios.api';
import ContainerPainel from 'components/container_painel';
import { Loading } from 'components/login';
import DocumentComponent from 'components/shared/document_component';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormularioPoliticaMunicipalAgriculturaFamiliarStore } from '../../../../../stores/forms/FormularioPMAF.store';
import { ROUTES } from 'routes/constants';
import BottomActionButtons from 'components/shared/bottom_action_buttons';

const TIPOS_INSTRUMENTO = [
  { value: 1, label: 'Lei' },
  { value: 2, label: 'Decreto' },
  { value: 3, label: 'Portaria' },
  { value: 4, label: 'Resolução' },
];

// Função utilitária para exibir o texto do tipo de instrumento
function getTipoInstrumentoTexto(tipo: number | null): string {
  const found = TIPOS_INSTRUMENTO.find(opt => opt.value === tipo);
  return found ? found.label : 'Não informado';
}

const FormPMAFEditar: React.FC = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const {
    formulario,
    setFormulario,
    setPartialForm,
    salvarRascunho,
    enviarAprovacao
  } = useFormularioPoliticaMunicipalAgriculturaFamiliarStore();

  const [loading, setLoading] = useState(true);

  const formik = useFormik({
    initialValues: {
      municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena: formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena,
      tipo_de_instrumento: formulario?.tipo_de_instrumento,
      numero_da_publicacao: formulario?.numero_da_publicacao,
      data_da_publicacao: formulario?.data_da_publicacao,
      upload_documento: formulario?.upload_documento,
      possui_plano_municipal_agricultura_familiar: formulario?.possui_plano_municipal_agricultura_familiar,
      upload_plano_pmaf: formulario?.upload_plano_pmaf,
    },
    onSubmit: (values) => {
      console.log(values);
    }
  })

  const getFormulario = async () => {
    try {
      if (!uuid) {
        throw new Error('UUID não fornecido');
      }

      const response = await getFormularioPoliticaMunicipalAgriculturaFamiliarByUUID(uuid);

      if (response.dados) {
        setFormulario(response.dados);
      }
    } catch (error) {
      console.error('Erro ao carregar formulário:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFormulario();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return (
      <ContainerPainel
        pagina='Formulário da Política Municipal da Agricultura Familiar'
        showBackButton={true}
      >
        <Loading />
      </ContainerPainel>
    );
  }


  // CRUD para Gerente Municipal
  const possuiPolitica = formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena;
  const possuiPlano = formulario?.possui_plano_municipal_agricultura_familiar;

  // Função para verificar se um campo específico tem erro
  const temErro = (campo: string) => {
    const possuiPolitica = formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena;
    const possuiPlano = formulario?.possui_plano_municipal_agricultura_familiar;

    switch (campo) {
      case 'possui_politica':
        return possuiPolitica === null || possuiPolitica === undefined;
      case 'tipo_instrumento':
        return possuiPolitica === true && !formulario?.tipo_de_instrumento;
      case 'numero_publicacao':
        return possuiPolitica === true && !formulario?.numero_da_publicacao;
      case 'data_publicacao':
        return possuiPolitica === true && !formulario?.data_da_publicacao;
      case 'upload_documento':
        return possuiPolitica === true && !formulario?.upload_documento;
      case 'possui_plano':
        return possuiPlano === null || possuiPlano === undefined;
      case 'upload_plano':
        return possuiPlano === true && !formulario?.upload_plano_pmaf;
      default:
        return false;
    }
  };

  const isFormValid = () => {
    if (formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === null ||
      formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === undefined) {
      return false;
    }
    if (formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === true) {
      if (
        !formulario.tipo_de_instrumento ||
        !formulario.numero_da_publicacao ||
        !formulario.data_da_publicacao ||
        !formulario.upload_documento
      ) {
        return false;
      }
    }
    if (formulario?.possui_plano_municipal_agricultura_familiar === null ||
      formulario?.possui_plano_municipal_agricultura_familiar === undefined) {
      return false;
    }
    if (formulario?.possui_plano_municipal_agricultura_familiar === true &&
      !formulario?.upload_plano_pmaf) {
      return false;
    }
    return true;
  };

  const handlePossuiPoliticaChange = (value: boolean) => {
    setPartialForm('municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena', value);

    // Se mudou para "Não", limpar os campos opcionais
    if (!value) {
      setPartialForm('tipo_de_instrumento', null);
      setPartialForm('numero_da_publicacao', null);
      setPartialForm('data_da_publicacao', null);
      setPartialForm('upload_documento', null);
    }
  };

  const handlePossuiPlanoChange = (value: boolean) => {
    setPartialForm('possui_plano_municipal_agricultura_familiar', value);
    if (!value) {
      setPartialForm('upload_plano_pmaf', null);
    }
  };

  const handleSalvarRascunho = async () => {
    try {
      const resultado = await salvarRascunho();
      if (resultado) {
        alert('Rascunho salvo com sucesso!');
        navigate(ROUTES.PACOTE_FORMULARIOS);
      } else {
        alert('Erro ao salvar rascunho. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao salvar rascunho:', error);
      alert('Erro ao salvar rascunho. Tente novamente.');
    }
  };

  const handleEnviarAprovacao = async () => {
    try {
      if (!isFormValid()) {
        alert('Preencha todos os campos obrigatórios antes de enviar para aprovação.');
        return;
      }
      const resultado = await enviarAprovacao();
      if (resultado) {
        navigate('/pacote-de-formularios');
      } else {
        alert('Erro ao enviar para aprovação. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao enviar para aprovação:', error);
      alert('Erro ao enviar para aprovação. Tente novamente.');
    }
  };

  return (
    <ContainerPainel
      pagina='Formulário da Política Municipal da Agricultura Familiar'
      showBackButton={true}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '2rem' }}>
        <Card sx={{ width: '100%', maxWidth: '800px' }}>
          <Box
            sx={{
              backgroundColor: '#0048b6',
              color: 'white',
              padding: '1rem',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
              textAlign: 'center',
            }}
          >
            <Typography variant='h6' fontWeight='bold'>
              Política Municipal da Agricultura Familiar
            </Typography>
            <Typography variant='subtitle2'>
              INFORMAÇÕES SOBRE A POLÍTICA MUNICIPAL DA AGRICULTURA FAMILIAR
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Stack spacing={4}>
              <Alert severity="info">
                O preenchimento deste formulário é feito em uma única etapa. Todos os campos obrigatórios devem ser preenchidos para salvar.
              </Alert>

              {/* Campo 1: O município possui Política Municipal de Agricultura Familiar? */}
              <FormControl component='fieldset' required error={temErro('possui_politica')}>
                <Typography
                  variant='subtitle1'
                  gutterBottom
                  sx={{
                    fontWeight: 'bold',
                    color: temErro('possui_politica') ? 'error.main' : 'inherit'
                  }}
                >
                  O município possui Política Municipal de Agricultura Familiar? *
                  {temErro('possui_politica') && (
                    <Typography variant='caption' display='block' color='error'>
                      Este campo é obrigatório
                    </Typography>
                  )}
                </Typography>
                <RadioGroup
                  row
                  value={possuiPolitica === true ? 'Sim' : possuiPolitica === false ? 'Não' : ''}
                  onChange={(e) => handlePossuiPoliticaChange(e.target.value === 'Sim')}
                >
                  <FormControlLabel value='Sim' control={<Radio />} label='Sim' />
                  <FormControlLabel value='Não' control={<Radio />} label='Não' />
                </RadioGroup>
              </FormControl>

              {/* Campos condicionais - só aparecem se "Sim" */}
              {possuiPolitica === true && (
                <>
                  {/* Campo 2: Tipo do Instrumento/Dispositivo Legal */}
                  <Box>
                    <Typography
                      variant='subtitle1'
                      gutterBottom
                      sx={{
                        fontWeight: 'bold',
                        color: temErro('tipo_instrumento') ? 'error.main' : 'inherit'
                      }}
                    >
                      Qual o Tipo do Instrumento/Dispositivo Legal? *
                      {temErro('tipo_instrumento') && (
                        <Typography variant='caption' display='block' color='error'>
                          Este campo é obrigatório
                        </Typography>
                      )}
                    </Typography>
                    <FormControl fullWidth required error={temErro('tipo_instrumento')}>
                      <Select
                        value={formulario?.tipo_de_instrumento || ''}
                        onChange={(e) => setPartialForm('tipo_de_instrumento', e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value='' disabled>
                          Selecione uma opção
                        </MenuItem>
                        {TIPOS_INSTRUMENTO.map(opt => (
                          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {/* Campo 3: Número da publicação */}
                  <Box>
                    <Typography
                      variant='subtitle1'
                      gutterBottom
                      sx={{
                        fontWeight: 'bold',
                        color: temErro('numero_publicacao') ? 'error.main' : 'inherit'
                      }}
                    >
                      Número da publicação do instrumento legal que instituiu a Política *
                      {temErro('numero_publicacao') && (
                        <Typography variant='caption' display='block' color='error'>
                          Este campo é obrigatório
                        </Typography>
                      )}
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder='Ex: nº da Lei'
                      value={formulario?.numero_da_publicacao || ''}
                      onChange={(e) => setPartialForm('numero_da_publicacao', e.target.value)}
                      required
                      error={temErro('numero_publicacao')}
                    />
                  </Box>

                  {/* Campo 4: Data da publicação */}
                  <Box>
                    <Typography
                      variant='subtitle1'
                      gutterBottom
                      sx={{
                        fontWeight: 'bold',
                        color: temErro('data_publicacao') ? 'error.main' : 'inherit'
                      }}
                    >
                      Data de publicação do instrumento legal que instituiu a Política *
                      {temErro('data_publicacao') && (
                        <Typography variant='caption' display='block' color='error'>
                          Este campo é obrigatório
                        </Typography>
                      )}
                    </Typography>
                    <TextField
                      fullWidth
                      type='date'
                      value={formulario?.data_da_publicacao ? formulario.data_da_publicacao.split('T')[0] : ''}
                      onChange={(e) => {
                        const dateValue = e.target.value ? e.target.value : null;
                        setPartialForm('data_da_publicacao', dateValue);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      error={temErro('data_publicacao')}
                    />
                  </Box>

                  {/* Campo 5: Upload de documento */}
                  <Box>
                    <Box sx={{
                      border: temErro('upload_documento') ? '1px solid' : 'none',
                      borderColor: 'error.main',
                      borderRadius: '4px',
                      padding: temErro('upload_documento') ? '8px' : '0'
                    }}>
                      <DocumentComponent
                        uuid={formulario?.upload_documento || null}
                        setUuid={(uuid) => setPartialForm('upload_documento', uuid)}
                        podeSubstituir={true}
                        title='Faça o upload do documento comprobatório'
                        subtitle='Para dar continuidade ao preenchimento, é necessário anexar o documento legal correspondente (como Decreto, Lei, Portaria ou outro normativo oficial).'
                      />
                    </Box>
                  </Box>
                </>
              )}

              {/* Critério de Aceitação 5: Pergunta sobre o Plano Municipal da Agricultura Familiar */}
              <FormControl component='fieldset' required error={temErro('possui_plano')}>
                <Typography
                  variant='subtitle1'
                  gutterBottom
                  sx={{
                    fontWeight: 'bold',
                    color: temErro('possui_plano') ? 'error.main' : 'inherit'
                  }}
                >
                  O município possui o Plano Municipal da Agricultura Familiar – PMAF? *
                  {temErro('possui_plano') && (
                    <Typography variant='caption' display='block' color='error'>
                      Este campo é obrigatório
                    </Typography>
                  )}
                </Typography>
                <RadioGroup
                  row
                  value={possuiPlano === true ? 'Sim' : possuiPlano === false ? 'Não' : ''}
                  onChange={(e) => handlePossuiPlanoChange(e.target.value === 'Sim')}
                >
                  <FormControlLabel value='Sim' control={<Radio />} label='Sim' />
                  <FormControlLabel value='Não' control={<Radio />} label='Não' />
                </RadioGroup>
              </FormControl>

              {/* Upload do Plano Municipal da Agricultura Familiar */}
              {possuiPlano === true && (
                <Box>
                  <Box sx={{
                    border: temErro('upload_plano') ? '1px solid' : 'none',
                    borderColor: 'error.main',
                    borderRadius: '4px',
                    padding: temErro('upload_plano') ? '8px' : '0'
                  }}>
                    <DocumentComponent
                      uuid={formulario?.upload_plano_pmaf || null}
                      setUuid={(uuid) => setPartialForm('upload_plano_pmaf', uuid)}
                      podeSubstituir={true}
                      title='Faça o upload do Plano Municipal da Agricultura Familiar (PDF)'
                      subtitle='Para dar continuidade ao preenchimento, é necessário anexar o documento do Plano Municipal da Agricultura Familiar (PDF).'
                    />
                  </Box>
                </Box>
              )}

              {/* Botões */}
              <BottomActionButtons
                handleSalvarRascunho={handleSalvarRascunho}
                handleEnviarAprovacao={handleEnviarAprovacao}
                isFormValid={isFormValid()}
                handleCancelar={() => navigate(-1)}
              />
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </ContainerPainel>
  );
};

export default FormPMAFEditar;
